import { render } from "./ToolTypeForm.vue?vue&type=template&id=ca733f36"
import script from "./ToolTypeForm.vue?vue&type=script&lang=js"
export * from "./ToolTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__